import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { SeparatedLists } from "../../../../components/separatedLists/SeparatedLists";
import { UrlList } from "../urlList/UrlList";
import AddUrlSection from "../addUrlSection/AddUrlSection";
import { ModalService } from "../../../../components/modal";
import { RemoveAllDialog } from "../removeAllDialog/RemoveAllDialog";
import {
  clearCheckUrl,
  clearCsvFile,
  load,
  removeItem,
} from "../../urlFilters.actions";
import { geProfileUrlFilters } from "../../urlFilters.selectors";

import "./UrlFiltersContent.scss";

const listsConfig = [
  {
    name: "black_list_blocked",
    key: "blacklist",
    icon: "fa-ban color-danger",
  },
  {
    name: "white_list_allowed",
    key: "whitelist",
    icon: "fa-check color-success",
  },
];

export const UrlFiltersPageTitle = ({ showDescription, ...attrs }) => {
  return (
    <div {...attrs}>
      <h1>
        <FormattedMessage id={"url_filters"} />
      </h1>

      {showDescription && (
        <p>
          <FormattedMessage id={"bwlists_description_global"} />
        </p>
      )}
    </div>
  );
};

const openModal = (list) =>
  ModalService.show((modal) => ({
    dialog: <RemoveAllDialog list={list} modal={modal} />,
  }));

export default function UrlFiltersContent({ profileId }) {
  const lists = useSelector(geProfileUrlFilters(profileId));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(load(_.map(listsConfig, "key"), profileId));
    dispatch(clearCheckUrl());
    dispatch(clearCsvFile());
  }, [dispatch, profileId]);

  return (
    <section className="url-filters__content">
      <div className={"sr-only"}>
        <h2>
          <FormattedMessage id={"url_filters"} />
        </h2>
      </div>

      <AddUrlSection profileId={profileId} />
      <section>
        <h2>
          <FormattedMessage id={"lists"} />
        </h2>
        <SeparatedLists>
          {_.map(listsConfig, ({ name, icon, key }) => (
            <UrlList
              key={key}
              nameKey={name}
              icon={icon}
              items={_.get(lists, `${key}.content`, [])}
              onItemRemove={(item) =>
                dispatch(removeItem(key, [item], profileId))
              }
              onClear={() =>
                openModal(name)
                  .then(() =>
                    dispatch(
                      removeItem(
                        key,
                        _.get(lists, `${key}.content`, []),
                        profileId
                      )
                    )
                  )
                  .catch(() => null)
              }
            />
          ))}
        </SeparatedLists>
      </section>
    </section>
  );
}

UrlFiltersContent.propTypes = {
  profileId: PropTypes.string,
};
